/** @module SiteAdmin/Document/OwnerTableFromDocument */
define([
    "dojo/_base/declare",
    "./OwnerTable"
    ], function(declare,OwnerTable) {

    return declare(OwnerTable, {
        /**
         * @override
         * Returning DocumentContainer when Document is the view node
         */
        retrieveContainer: function(){
            const viewNode = this.getViewNode();
            return (viewNode ? this.cacheView.getNode(viewNode.__Parent__) : null);
        }
    });
});
